import React from 'react';
import './Assets/styles/main.scss';
import Header from './Components/Header';
import SideMenu from './Components/SideMenu';
import NavCalendar from './Components/NavCalendar';
import Calendar from './Components/Calendar';
import Modals from './Components/Modals';
import QRscannerModal from './Components/Modals/QRscanner';
import ReservationForm from './Components/Modals/Reservation/Form';
import AnalyticsPage from './Components/Pages/AnalyticsPage';
import BottomCalendarNavigator from './Components/BottomCalendarNavigator';
import { withRouter } from 'react-router-dom';
import { withAllContexts } from './AllContextsWrapper';
import { Box } from "@mui/material";

class App extends React.Component {
  constructor (props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    this.handleDeepLinks();
  }

  handleDeepLinks = () => {
    const { location } = this.props;
    const path = location ? location.pathname : window.location.pathname;
    const search = location ? location.search : window.location.search;

    if (path === '/admin') {
      this.props.app.functions.setShownComponent('admin');
    }

    // /calendar/:id/reservation/:resId
    const resMatch = path.match(/\/calendar\/(\d+)\/reservation\/(\d+)/);
    if (resMatch) {
      const calendarId = parseInt(resMatch[1]);
      const reservationId = parseInt(resMatch[2]);

      this.props.app.functions.setCalendar(calendarId);
      this.props.app.functions.updateCurrReservation(reservationId);
    }

    // /create_reservation?clientId=... or ?phone=...
    if (path.includes('/create_reservation')) {
      const urlParams = new URLSearchParams(search);
      const clientId = urlParams.get('clientId');
      const phone = urlParams.get('phone');
      
      this.props.app.functions.toggleAddNewReservation(new Date());
      this.setState({
        prefillClientId: clientId,
        prefillPhone: phone
      });
    }
  }

  componentDidUpdate(prevProps) {
    this.updateThemeColor();
    
    // Check if URL changed
    const currentPath = this.props.location ? this.props.location.pathname : window.location.pathname;
    const prevPath = prevProps.location ? prevProps.location.pathname : '';
    const currentSearch = this.props.location ? this.props.location.search : window.location.search;
    const prevSearch = prevProps.location ? prevProps.location.search : '';
    
    if (currentPath !== prevPath || currentSearch !== prevSearch) {
      this.handleDeepLinks();
    }
  }

  updateThemeColor = () => {
    const { activeCalendar } = this.props.app.state;
    const color = activeCalendar?.type === 'accommodation' ? '#1A3C34' : '#0D5D56';
    const metaThemeColor = document.querySelector("meta[name=theme-color]");
    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", color);
    }
  }

  render() {
    const { activeCalendar } = this.props.app.state;
    const themeClass = activeCalendar ? `theme-${activeCalendar.type}` : 'theme-rafting';

    return (
      <Box className={`App fixed inset-0 overflow-hidden flex flex-col ${themeClass}`}>

        <Header
          date={this.props.app.state.date}
          view={this.props.app.state.view}
          today={this.props.app.state.today}
          hideFilters={this.props.app.state.shownComponent === 'analytics'}
        />
        <SideMenu
          view={this.props.app.state.view}
        />
        <div className="content-wrapper">
          {this.props.app.state.shownComponent === 'analytics' ? (
            <div className="absolute inset-0 z-40 bg-white">
              <AnalyticsPage />
            </div>
          ) : (
            <>
              <div className={this.props.app.state.shownComponent === 'navCal' ? "side-wrapper shown" : "side-wrapper"}>
                <NavCalendar
                  date={this.props.app.state.navDate}
                  view={this.props.app.state.view}
                  today={this.props.app.state.today}
                />
              </div>
              <div className="main-wrapper">
                <Calendar
                  date={this.props.app.state.date}
                  view={this.props.app.state.view}
                  today={this.props.app.state.today}
                  updateCalendar={this.props.app.state.updateCalendar}
                />
              </div>
            </>
          )}
        </div>

        {this.props.app.state.shownComponent !== 'analytics' && (
          <BottomCalendarNavigator />
        )}

        <Modals
          addReservation={this.props.app.state.addReservation}
          addReservationDate={this.props.app.state.addReservationDate}
        />
        {/* Only show Form modal for NEW reservations, not for editing existing ones */}
        <ReservationForm
          isOpen={this.props.app.state.addReservation}
          initDate={this.props.app.state.addReservationDate}
          currentReservation={this.props.app.state.reservation}
          prefillClientId={this.state.prefillClientId}
          prefillPhone={this.state.prefillPhone}
          onPrefillDone={() => this.setState({ prefillClientId: null, prefillPhone: null })}
        />
        <QRscannerModal />
      </Box>
    );
  }
}

export default withRouter(withAllContexts(App));
